<template>
  <div class="">
    <img
      v-if="picture"
      :src="picture"
      alt="slika"
      class="client__picture"
      :style="{ height: imgSize }"
    />
    <div v-else class="">
      <svg
        version="1.0"
        width="50px"
        height="40px"
        viewBox="0 0 1280.000000 1237.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          transform="translate(0.000000,1237.000000) scale(0.100000,-0.100000)"
          fill="var(--purple)"
          stroke="none"
        >
          <path
            d="M6008 11881 c30 -14 28 -29 -8 -49 -16 -9 -30 -20 -30 -24 0 -5 -9
            -8 -19 -8 -11 0 -21 -4 -23 -8 -7 -16 -206 -90 -261 -96 -32 -3 -72 -13 -89
            -22 -33 -17 -178 -132 -178 -141 0 -3 6 -1 13 4 90 72 187 134 122 79 -16 -14
            -32 -26 -35 -26 -3 0 -34 -31 -68 -70 -46 -51 -55 -65 -35 -55 34 18 39 13 18
            -19 -10 -14 -15 -33 -11 -41 4 -11 2 -14 -6 -9 -8 5 -9 2 -5 -10 4 -9 3 -15
            -2 -11 -5 3 -14 -10 -21 -29 -6 -19 -21 -45 -33 -58 -40 -41 -89 -108 -79
            -108 5 0 17 9 27 20 10 11 20 18 23 15 3 -2 13 0 23 6 25 13 24 4 -3 -34 -15
            -20 -22 -47 -23 -83 -1 -30 1 -51 6 -49 4 3 10 -5 14 -17 3 -13 17 -51 31 -85
            21 -51 24 -65 14 -83 -7 -13 -8 -20 -2 -16 20 12 21 -25 1 -61 l-21 -38 21 25
            c25 30 27 14 6 -45 -18 -50 -18 -50 0 -35 12 10 13 7 5 -21 -5 -17 -7 -35 -5
            -39 4 -7 -7 -86 -21 -149 -4 -20 -3 -22 8 -13 11 9 14 -8 15 -92 2 -57 7 -115
            13 -130 9 -23 7 -28 -15 -36 -51 -19 -58 -46 -53 -207 5 -170 14 -202 90 -336
            56 -98 86 -125 121 -110 21 10 23 6 45 -76 25 -94 70 -198 106 -246 47 -61 76
            -394 44 -495 -23 -71 -115 -185 -239 -297 -134 -121 -135 -122 -228 -168 -91
            -46 -184 -69 -357 -90 -178 -22 -269 -45 -371 -95 -175 -86 -285 -254 -337
            -515 -34 -173 -39 -263 -41 -700 -2 -470 -7 -550 -66 -1060 -34 -289 -67 -486
            -104 -618 -39 -138 -61 -173 -213 -344 -50 -56 -109 -126 -130 -155 -40 -54
            -211 -331 -341 -556 -152 -260 -460 -702 -489 -702 -4 0 -14 13 -23 29 -23 39
            -64 48 -100 22 -29 -21 -49 -27 -49 -14 0 4 7 27 17 51 15 40 15 46 0 77 -19
            41 -56 54 -94 34 -15 -8 -54 -47 -87 -86 -33 -40 -64 -73 -68 -73 -3 0 -21
            -12 -39 -27 -38 -32 -68 -95 -69 -142 0 -48 -56 -147 -108 -189 -24 -21 -56
            -48 -71 -62 -25 -24 -94 -49 -138 -50 -12 0 -30 8 -40 19 -58 60 -183 52 -183
            -12 0 -50 47 -124 105 -167 77 -57 119 -73 170 -65 23 3 62 1 86 -6 78 -20
            113 -21 182 -5 67 16 70 15 95 -4 22 -18 40 -21 121 -21 53 0 123 0 156 -1 33
            -1 75 2 93 6 19 5 32 5 32 -1 0 -5 -44 -27 -97 -48 -258 -100 -474 -237 -585
            -369 -63 -76 -139 -219 -163 -311 -23 -86 -30 -213 -16 -287 16 -80 66 -185
            131 -270 66 -87 241 -263 338 -340 90 -70 94 -74 67 -61 -24 12 -48 6 -39 -9
            4 -7 2 -8 -4 -4 -7 4 -25 -8 -42 -28 -19 -21 -37 -33 -46 -29 -8 3 -14 0 -14
            -7 0 -6 5 -8 11 -4 7 4 10 1 7 -7 -3 -8 -10 -13 -17 -12 -6 2 -13 -8 -17 -21
            -4 -17 -15 -27 -35 -31 -16 -4 -27 -11 -23 -16 3 -5 10 -6 16 -3 7 4 8 2 4 -5
            -4 -6 -12 -9 -17 -6 -5 4 -9 1 -9 -5 0 -7 -7 -9 -16 -6 -8 3 -12 2 -9 -3 3 -5
            1 -12 -5 -16 -5 -3 -10 -1 -10 6 0 21 -13 0 -15 -24 -1 -13 -8 -21 -17 -19 -8
            1 -20 -9 -26 -23 -7 -16 -17 -23 -27 -19 -18 7 -21 -12 -2 -20 6 -3 1 -3 -13
            1 -22 5 -23 4 -12 -10 15 -17 8 -37 -11 -37 -7 0 -6 4 3 11 13 9 13 10 0 6 -8
            -2 -15 -12 -15 -23 0 -10 -4 -25 -9 -33 -7 -10 -6 -12 4 -6 10 6 12 0 8 -23
            -5 -34 11 -48 32 -29 10 10 10 8 1 -9 -9 -19 -7 -24 15 -39 15 -9 24 -12 20
            -7 -3 6 13 1 36 -11 24 -12 44 -25 46 -29 2 -5 12 -3 22 2 15 8 17 6 13 -9 -3
            -14 1 -17 19 -16 13 1 25 -1 28 -6 3 -4 21 -10 40 -12 19 -3 35 -6 35 -7 0 -1
            17 -3 37 -5 21 -1 45 -9 55 -16 11 -9 14 -10 9 -2 -4 7 -2 13 3 13 6 0 11 -4
            11 -9 0 -10 34 -19 90 -25 19 -2 47 -8 62 -14 15 -6 60 -14 100 -18 40 -3 76
            -8 80 -11 33 -19 765 -18 1218 1 52 3 160 7 240 10 81 4 173 8 205 11 33 2
            101 7 150 10 50 3 108 8 130 10 22 2 87 7 145 10 58 4 119 8 135 10 29 4 111
            11 230 20 33 3 83 7 110 10 107 10 163 15 230 20 134 9 220 16 310 25 50 6
            218 19 375 30 157 11 314 22 350 25 36 2 112 7 170 9 58 3 159 9 225 13 66 3
            644 7 1285 8 641 1 1201 5 1245 10 44 4 117 8 162 9 46 0 83 3 83 6 0 3 17 5
            38 6 20 0 60 4 87 7 28 4 68 9 90 12 22 2 51 7 65 10 27 6 93 13 177 19 28 2
            56 6 60 9 5 3 38 8 74 11 63 6 124 14 164 23 11 2 38 6 60 8 22 3 56 7 75 10
            19 3 53 8 75 10 22 3 58 9 80 15 79 21 90 23 113 23 12 -1 22 3 22 8 0 5 9 9
            21 9 12 0 17 4 14 11 -4 6 2 13 14 16 12 3 21 8 21 12 0 3 13 21 29 39 19 21
            31 28 34 20 2 -7 5 4 5 25 0 32 -4 40 -26 48 -21 8 -23 12 -12 19 9 6 18 5 23
            -3 6 -8 7 -8 4 3 -2 8 -13 14 -25 14 -13 -1 -19 3 -15 13 3 7 -2 22 -11 32 -9
            10 -13 21 -9 26 5 4 -3 2 -16 -5 -13 -6 -21 -7 -17 -2 3 6 2 13 -4 17 -18 11
            -40 63 -34 79 3 9 10 13 15 10 5 -3 9 -2 8 3 -4 24 2 43 13 37 6 -4 8 -3 4 4
            -3 6 -2 14 4 17 6 4 8 15 5 25 -4 12 2 27 15 40 11 11 21 30 23 43 1 12 9 30
            19 40 16 19 78 129 78 141 0 3 -8 3 -17 0 -10 -3 4 8 31 24 77 47 250 188 363
            296 88 83 109 110 143 180 49 99 63 187 49 317 -16 158 -57 235 -204 385 -85
            86 -113 108 -185 143 -47 22 -122 51 -167 63 -63 18 -83 27 -83 40 0 31 -45
            51 -100 46 -27 -3 -47 -1 -44 4 3 4 26 8 52 8 31 0 59 8 82 22 22 13 54 22 85
            23 36 1 69 12 117 38 37 20 93 43 125 53 132 38 138 42 215 128 75 86 147 219
            134 251 -10 26 -53 36 -99 24 -38 -10 -107 -67 -107 -89 0 -4 -23 -23 -52 -41
            -39 -25 -75 -38 -140 -50 -49 -8 -90 -14 -92 -12 -2 2 3 26 12 52 l15 49 -86
            179 c-103 217 -179 333 -219 333 -17 0 -35 -10 -52 -31 -28 -33 -32 -53 -16
            -94 9 -25 9 -26 -12 -18 -37 13 -208 6 -276 -11 -34 -9 -98 -32 -140 -51 -141
            -62 -147 -62 -271 0 -172 86 -400 263 -925 714 -325 280 -343 294 -486 396
            -146 104 -224 178 -250 238 -10 23 -28 95 -40 160 -11 64 -27 145 -34 179 -23
            98 -43 248 -80 578 -52 456 -56 535 -54 900 2 232 -1 366 -10 435 -39 297
            -105 469 -226 590 -111 111 -241 162 -496 195 -85 11 -184 27 -220 36 -105 26
            -216 85 -303 161 -43 37 -101 88 -130 112 -54 46 -145 161 -174 221 -22 44
            -24 216 -4 343 12 83 17 93 57 138 53 60 92 135 130 252 24 75 31 87 50 87 27
            0 45 25 102 137 57 111 72 174 79 334 6 130 5 137 -16 158 -11 11 -32 21 -45
            21 -24 0 -24 1 -10 28 7 15 14 48 14 74 0 26 5 50 10 53 6 4 8 10 5 15 -3 4
            -2 16 1 25 5 13 8 14 15 3 8 -13 14 28 11 77 0 11 -3 81 -6 156 l-6 135 40 18
            c46 20 56 44 46 112 -9 65 -30 98 -82 129 -45 26 -46 29 -40 64 14 77 18 168
            9 201 -7 27 -17 37 -41 45 -24 8 -29 14 -22 25 14 22 12 30 -9 30 -10 0 -24 7
            -31 15 -7 8 -18 15 -25 15 -7 0 -15 7 -19 15 -6 17 -62 20 -86 5 -8 -5 -10
            -10 -5 -10 15 0 -18 -20 -34 -20 -11 0 -11 3 -1 15 11 13 10 14 -2 10 -22 -9
            -45 41 -30 65 11 18 9 19 -17 14 -28 -6 -29 -5 -36 45 -8 63 -29 89 -51 66
            -21 -21 -21 -20 -44 28 -11 23 -29 53 -40 67 l-19 25 6 -24 c6 -22 2 -21 -48
            16 -52 39 -119 78 -119 69 0 -2 20 -17 45 -33 25 -15 45 -32 45 -37 0 -5 -8
            -2 -18 7 -29 26 -38 20 -12 -8 13 -14 19 -25 14 -25 -5 0 -18 14 -29 30 -11
            16 -24 30 -28 30 -5 0 -33 20 -63 45 -31 24 -74 50 -97 56 -23 6 -107 12 -187
            14 -80 1 -156 6 -170 9 -24 6 -24 6 -2 -3z m399 -67 c-3 -3 -12 -4 -19 -1 -8
            3 -5 6 6 6 11 1 17 -2 13 -5z m827 -869 c3 -17 8 -49 12 -71 4 -25 2 -49 -5
            -60 -9 -15 -10 -10 -5 24 8 50 -1 56 -15 10 -9 -30 -10 -28 -4 12 8 58 7 90
            -2 115 -6 15 -5 17 3 10 7 -6 14 -24 16 -40z m56 -105 c0 -5 -5 -10 -11 -10
            -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m-2383 -6055 c10 -82 17 -196
            16 -252 -2 -91 -5 -108 -32 -162 -17 -34 -34 -85 -37 -118 -4 -31 -15 -71 -25
            -88 -10 -16 -24 -57 -32 -90 -8 -33 -26 -85 -41 -116 -14 -31 -26 -64 -26 -74
            0 -9 -8 -34 -19 -54 -32 -63 -89 -184 -111 -236 -11 -27 -39 -79 -60 -115 -22
            -36 -51 -96 -65 -133 -14 -37 -47 -95 -73 -127 -43 -55 -50 -60 -86 -60 -76 0
            -254 -32 -421 -76 -93 -24 -264 -69 -380 -99 -115 -29 -259 -70 -320 -89 -60
            -19 -111 -34 -113 -32 -2 2 38 41 88 87 51 46 131 134 178 194 106 135 269
            304 467 483 218 198 784 768 826 832 81 123 105 187 149 410 31 157 56 263 67
            290 3 8 12 -39 19 -105 8 -66 22 -187 31 -270z m2832 106 c66 -266 89 -327
            146 -389 98 -110 500 -338 1240 -706 262 -131 502 -258 615 -326 186 -113 331
            -190 359 -190 8 0 58 -24 110 -53 53 -30 127 -71 166 -92 38 -21 64 -40 58
            -42 -6 -2 -152 16 -325 41 -390 56 -411 59 -808 96 -179 17 -379 38 -445 47
            -79 11 -205 17 -373 19 l-253 2 -39 44 c-21 25 -55 55 -75 69 -20 13 -47 45
            -61 72 -14 27 -46 76 -71 110 -25 34 -58 89 -73 122 -15 33 -34 66 -43 74 -10
            7 -17 20 -17 27 0 8 -11 35 -24 61 -42 81 -86 189 -86 209 0 10 -10 39 -21 64
            -12 25 -27 76 -35 113 -7 38 -24 88 -38 112 -45 82 -44 194 4 626 6 48 10 101
            10 120 0 67 19 10 79 -230z m3414 -3406 c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2 15
            9 16 15 13 8 -4z m-66 -442 c-8 -7 -37 9 -31 19 3 5 12 4 20 -3 8 -6 13 -14
            11 -16z"
          />
          <path
            d="M11051 1121 c-8 -5 -9 -11 -3 -15 5 -3 12 1 16 9 6 17 6 18 -13 6z"
          />
          <path
            d="M2260 950 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
            -4 -4 -4 -10z"
          />
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    picture: {
      type: String,
      default: null,
    },
    imgSize: {
      type: String,
      default: '2em',
    },
  },
};
</script>

<style>
.client__picture {
  border-radius: 50%;
}
</style>
